module.exports = __webpack_public_path__ + "78728eb8cb32d92fa3618287419e7a85.MP3";